import { StateParams } from '@uirouter/core';
import * as angular from 'angular';
import { ICampaignSchedule } from '../../../campaigns/models';
import { AnalyticsService, ICollectedAnalyticsData } from '../../analytics.service';
import { AnalyticsBase } from '../../analyticsBase';

class CampaignAnalyticsComponent extends AnalyticsBase {
    public static $inject = ['$scope', '$stateParams', '$filter', 'analyticsService', '$translate'];

    private schedule: ICampaignSchedule;
    constructor(
        protected $scope: ng.IScope,
        protected $stateParams: StateParams,
        protected $filter: ng.IFilterService,
        protected analiticsService: AnalyticsService,
        protected $translate: angular.translate.ITranslateService
    ) {
        super($scope, $stateParams, $filter, analiticsService, $translate);
    }

    protected getData(id: number, filter: any): angular.IPromise<ICollectedAnalyticsData[]> {
        return this.analiticsService.getCampaignAnalytics(this.id, this.filter);
    }

    public $onInit() {
        this.setFilterExtension();
    }
    protected setFilterExtension() {
        if (!this.schedule) {
            return;
        }
        if (this.schedule.hasStartDate) {
            this.filter.startDate = new Date(this.schedule.startDate.toString()).setHours(0, 0, 0, 0);
        }
        if (this.schedule.hasEndDate) {
            this.filter.endDate = new Date(this.schedule.endDate.toString()).setHours(0, 0, 0, 0);
        }
    }
}

angular.module('naut').component('campaignAnalytics', {
    template: require('./campaignAnalytics.html'),
    controller: CampaignAnalyticsComponent,
    controllerAs: 'vm',
    bindings: {
        schedule: '<',
    }
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/analytics/components/campaignAnalytics/campaignAnalytics.component.ts